import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { ANNOUNCEMENT_FRAGMENT } from '@base/api/fragments/announcement'

export const ANNOUNCEMENT_QUERY = gql`
  ${ANNOUNCEMENT_FRAGMENT}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  query listAnnouncements($clubSlug: String, $eventSlug: String) {
    listAnnouncements(
      filter: {
        clubSlug: $clubSlug
        eventSlug: $eventSlug
        timeBlocked: true
        includeDeactivated: false
      }
      sort: [{ sortField: POSITION, sortOrder: ASC }]
    ) {
      ... on ListAnnouncementsOutput {
        announcements {
          ...Announcement
        }
      }
      ... on ListAnnouncementsErrorOutput {
        errors {
          sort
          offset
          clubId
          clubSlug
          eventId
          eventSlug
        }
      }
      ...ServerError
      ...UnauthenticatedError
      ...UnauthorizedError
    }
  }
`
